// WRISTORIAN Enquiry Modal Handler

(function() {
  const modal = document.getElementById('wristorian-enquiry-modal');
  const openBtn = document.getElementById('open-enquiry-modal');
  const closeBtn = document.querySelector('.wristorian-modal-close');
  const form = document.getElementById('wristorian-enquiry-form');
  const formContent = document.getElementById('enquiry-form-content');
  const successContent = document.getElementById('enquiry-success-content');
  const returnBtn = document.getElementById('return-to-product');

  if (!modal || !openBtn) return;

  // Open modal
  openBtn.addEventListener('click', function(e) {
    e.preventDefault();
    modal.style.display = 'flex';
    setTimeout(() => modal.classList.add('active'), 10);
    document.body.style.overflow = 'hidden';
  });

  // Close modal function
  function closeModal() {
    modal.classList.remove('active');
    setTimeout(() => {
      modal.style.display = 'none';
      formContent.style.display = 'block';
      successContent.style.display = 'none';
      form.reset();
    }, 300);
    document.body.style.overflow = '';
  }

  // Close button
  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal);
  }

  // Click outside to close
  modal.addEventListener('click', function(e) {
    if (e.target === modal) {
      closeModal();
    }
  });

  // ESC key to close
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      closeModal();
    }
  });

  // Form submission - COMPLETELY OVERRIDE
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      
      const formData = new FormData(form);
      
      // Show success state immediately
      formContent.style.display = 'none';
      successContent.style.display = 'block';
      
      // Submit via XMLHttpRequest to prevent any page navigation
      const xhr = new XMLHttpRequest();
      xhr.open('POST', '/contact', true);
      xhr.onload = function() {
        console.log('Form submitted successfully');
      };
      xhr.onerror = function() {
        console.error('Submission error');
        formContent.style.display = 'block';
        successContent.style.display = 'none';
        alert('There was an error submitting your enquiry. Please try again.');
      };
      xhr.send(formData);
      
      return false;
    }, true);
  }

  // Return to product button
  if (returnBtn) {
    returnBtn.addEventListener('click', closeModal);
  }
})();
